<div class="row-sm text-center">
    <img alt="Panini's logo" src="../../assets/imgs/Panini.png" />
</div>
<div class="row mt-3">
    <div class="col d-flex justify-content-center">
        <div id="cookieContainer">

    </div>
</div>

